import { inject, Injectable } from '@angular/core';

import type { InputSelectConfig } from '@core/ask-hr-dynamic-forms-types';
import { priorityColorMap } from '@core/ask-hr-templates-util';
import type { AskTicketPriority } from '@core/ask-hr-types';
import { I18nService } from '@core/i18n-legacy';

@Injectable({ providedIn: 'root' })
export class PriorityService {
  private readonly i18n = inject(I18nService);

  public getPriorityConfig(opts: { isDisabled: boolean }): InputSelectConfig<AskTicketPriority> {
    return {
      kind: 'radio',
      question: this.i18n.translate('tlc.ask_hr.form_template_create.what_is_the_priority'),
      hint: '',
      required: true,
      disabled: opts.isDisabled,
      options: [
        {
          value: 'low',
          label: this.i18n.translate('tlc.ask_hr.requests.priority_levels.low'),
          symbol: { type: 'icon', source: 'internal', name: 'flag', color: priorityColorMap.low },
        },
        {
          value: 'normal',
          label: this.i18n.translate('tlc.ask_hr.requests.priority_levels.normal'),
          symbol: {
            type: 'icon',
            source: 'internal',
            name: 'flag',
            color: priorityColorMap.normal,
          },
        },
        {
          value: 'high',
          label: this.i18n.translate('tlc.ask_hr.requests.priority_levels.high'),
          symbol: { type: 'icon', source: 'internal', name: 'flag', color: priorityColorMap.high },
        },
        {
          value: 'urgent',
          label: this.i18n.translate('tlc.ask_hr.requests.priority_levels.urgent'),
          symbol: {
            type: 'icon',
            source: 'internal',
            name: 'flag',
            color: priorityColorMap.urgent,
          },
        },
      ],
    };
  }
}
